/**
 * `useDashboard` — the "My work" landing data (`GET /dashboard`; UI/UX Flow 9). One
 * request, membership-scoped server-side. Fresh for 30 s (`STALE_LIVE_MS`) so a bounce back
 * to the dashboard from a case does not refetch, and — the one screen that opts in — it
 * refetches on window focus once stale, because it is the "what changed while I was away"
 * view. Live case updates invalidate it through the same `['dashboard']` key when screens
 * mutate cases/documents/reports/annotations.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { api, type DashboardResponse } from '../lib/api.ts';
import { STALE_LIVE_MS } from '../lib/query-client.ts';

export const DASHBOARD_QUERY_KEY = ['dashboard'] as const;

export function useDashboard(enabled = true): UseQueryResult<DashboardResponse> {
  return useQuery<DashboardResponse>({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: () => api.dashboard.get(),
    staleTime: STALE_LIVE_MS,
    refetchOnWindowFocus: true,
    enabled,
  });
}
